// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "date-jrWjS";
var _4 = "timeEnRoute__text-2ZabX";
var _5 = "short-1OCW_";
var _6 = "filled-38ZKP";
var _7 = "timeEnRoute-EX0D7";
var _8 = "airport__city-cOC4Y";
var _9 = "details-3N7nf";
var _a = "details__short-1OqXQ";
var _b = "airport__name-2QYui";
var _c = "details__arrow-1Uher";
var _d = "flight_withAircraft-1ha8i";
var _e = "segments-28qrv";
export { _1 as "__esModule", _2 as "mobile", _3 as "date", _4 as "timeEnRoute__text", _5 as "short", _6 as "filled", _7 as "timeEnRoute", _8 as "airport__city", _9 as "details", _a as "details__short", _b as "airport__name", _c as "details__arrow", _d as "flight_withAircraft", _e as "segments" }
export default { "__esModule": _1, "mobile": _2, "date": _3, "timeEnRoute__text": _4, "short": _5, "filled": _6, "timeEnRoute": _7, "airport__city": _8, "details": _9, "details__short": _a, "airport__name": _b, "details__arrow": _c, "flight_withAircraft": _d, "segments": _e }
